import React, { useState } from 'react';
import { COLOR } from '@src/styles/color';
import { StyledAudio, StyledAudioSlider } from './index.style';

const AudioSlider = (props) => {
  const {
    currentTime,
    duration,
    onSeeked,
    disabled,
    color,
    hightThumb,
    widthThumb,
  } = props;

  const [isSeeking, setIsSeeking] = useState(false);
  const [seekValue, setSeekValue] = useState(0);

  const handleChange = (e, value) => {
    setIsSeeking(true);
    setSeekValue(value);
  };

  const handleChangeCommitted = (e, value) => {
    setIsSeeking(false);
    onSeeked(value / 1000);
  };

  const displayValue = isSeeking ? seekValue : currentTime * 1000;

  return (
    <StyledAudio>
      <StyledAudioSlider
        value={displayValue}
        step={1}
        min={0}
        max={duration === 0 ? 1 : duration * 1000}
        onChange={handleChange}
        onChangeCommitted={handleChangeCommitted}
        disabled={disabled}
        sx={{
          color: color || COLOR.primary,
          '& .MuiSlider-thumb': {
            height: hightThumb || '20px',
            width: widthThumb || '20px',
            backgroundColor: color || COLOR.white,
            border: `1px solid currentColor`,
          },
        }}
      />
    </StyledAudio>
  );
};

export default AudioSlider;
